const defaultState = {
  default: {
    url: "/",
  },
};

export default {
  namespaced: true,
  state: defaultState,
  mutations: {
    setDefault (state, data) {
      Object.keys(data).map(key => {
        state.default[key] = data[key];
      });
    },
    init (state) {
      Object.assign(state, defaultState);
    },
  },
};
